/* eslint-disable no-nested-ternary */
import { createSlice } from '@reduxjs/toolkit';
// utils
import { de } from 'date-fns/locale';
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  countries: [],
  city: [],
  lotto: [],
  agents: [],
  supervisors: [],
  surcussales: [],
  tirages: [],
  fiches: [],
  fichesupps: [],
  fichegagnants: [],
  fichepayants: [],
  borletteConf: [],
  transaction: [],
  typeGame: {
    data: [],
    total: 0,
    next: null,
    previous: null
  },
  typeGameAgent: [],
  typeBoule: {
    data: [],
    total: 0,
    page: 1,
    pageSize: 25
  },
  typeBouleAgent: {
    data: [],
    total: 0,
    page: 1,
    pageSize: 25
  },
  primeConfs: null,
  tirageprimeConfs: [],
  agentprimeConfs: [],
  surcussaleprimeConfs: [],
  app: null,
  appJournalier: null,
  appTirageLotgagnant: [],
  appTirage: null,
  appFiche: null,
  appLotto: null,
  appGain: null,
  appGpc: null,
  infotirages: [],
  boules: [],
  statistiques: [],
  tracabiliteAgent: [],
  tracabiliteSupervisor: [],
  tracabiliteCompany: [],
  info_tirages: [],
  rapports: [],
  reportAgent: [],
  rapportagents: [],
  controlAgent: [],
  controlSuperviseur: [],
  agentRapport: [],
  supRapport: [],
  agentsupRapport: null,
  lotgagnants: [],
  compagnies: [],
  companyPayment: [],
  promote: [],
  facturations: [],
  url: [],
  intervalemas: {
    data: [],
    total: 0,
    next: null,
    previous: null
  },
  mariageSurcussale: [],
  decaissement: [],
  mariageAgent: [],
  total: 0,
  page: 1,
  pageSize: 1
};

const slice = createSlice({
  name: 'user',
  initialState,
  typeGameAgent: {
    data: [],
    total: 0
  },
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET COUNTRIES
    getCountriesSuccess(state, action) {
      state.isLoading = false;
      state.countries = action.payload;
    },

    // GET CITY
    getCitySuccess(state, action) {
      state.isLoading = false;
      state.city = action.payload;
    },

    // GET LOTTO
    getLottoSuccess(state, action) {
      state.isLoading = false;
      state.lotto = action.payload;
    },

    // GET AGENTS
    getAgentsSuccess(state, action) {
      state.isLoading = false;
      state.agents = action.payload;
    },
    // GET REPORT AGENT
    getReportSuccess(state, action) {
      state.isLoading = false;
      state.reportAgent = action.payload;
    },
    // GET REPORT suoperviseur
    getReportSuperviseurSuccess(state, action) {
      state.isLoading = false;
      state.reportSupervisor = action.payload;
    },
    // GET SUPERVISORS
    getSupervisorsSuccess(state, action) {
      state.isLoading = false;
      state.supervisors = action.payload;
    },

    // GET SUPERVISEUR
    getSuperviseurSucees(state, action) {
      state.isLoading = false;
      state.controlSuperviseur = action.payload;
    },

    // GET SURCUSSALES
    getSurcussaleSuccess(state, action) {
      state.isLoading = false;
      state.surcussales = action.payload;
    },

    getSurcussaleConfSuccess(state, action) {
      state.isLoading = false;
      state.surcussaleprimeConfs = action.payload;
    },
    // GET TIRAGES
    getTirageSuccess(state, action) {
      state.isLoading = false;
      state.tirages = action.payload;
    },

    // GET FICHES
    getFicheSuccess(state, action) {
      state.isLoading = false;
      state.fiches = action.payload;
    },

    // GET FICHES GAGNANTS
    getFicheGagnantSuccess(state, action) {
      state.isLoading = false;
      state.fichegagnants = action.payload;
    },
    getFichePayantSuccess(state, action) {
      state.isLoading = false;
      state.fichepayants = action.payload;
    },
    // GET FICHES SUPP
    getFicheSuppSuccess(state, action) {
      state.isLoading = false;
      state.fichesupps = action.payload;
    },

    // GET BOULES
    getBouleSuccess(state, action) {
      state.isLoading = false;
      state.error = null; // Réinitialise les erreurs

      const payload = action.payload || {};

      // Assure que nous avons toujours la bonne structure
      state.boules = {
        data: Array.isArray(payload.results)
          ? payload.results
          : Array.isArray(payload.data)
          ? payload.data
          : [],
        total: Number.isInteger(payload.count)
          ? payload.count
          : Number.isInteger(payload.total)
          ? payload.total
          : 0,
        next: payload.next || null,
        previous: payload.previous || payload.prev || null
      };

      // Optionnel: Log pour debug
      console.log('Boules chargées:', {
        count: state.boules.data.length,
        total: state.boules.total
      });
    },

    getIntervalMaSuccess(state, action) {
      state.isLoading = false;
      // Si l'API retourne un tableau directement
      const isArray = Array.isArray(action.payload);
      state.intervalemas = {
        data: isArray ? action.payload : action.payload.results || [],
        total: isArray ? action.payload.length : action.payload.count || 0,
        next: isArray ? null : action.payload.next,
        previous: isArray ? null : action.payload.previous
      };
    },

    // GET PRIMECONF
    getPrimeConfSuccess(state, action) {
      state.isLoading = false;
      state.primeConfs = action.payload;
    },

    // GET TIRAGECONF
    getTirageConfSuccess(state, action) {
      state.isLoading = false;
      state.tirageprimeConfs = action.payload;
    },

    // GET AGENTCONF
    getAgentConfSuccess(state, action) {
      state.isLoading = false;
      state.agentprimeConfs = action.payload;
    },
    // GET SURCUSSALECONF
    getSurcussalConfs(state, action) {
      state.isLoading = false;
      state.surcussaleprimeConfs = action.payload;
    },

    // GET APP
    getAppSuccess(state, action) {
      state.isLoading = false;
      state.app = action.payload;
    },

    // GET APP JOURNALIER
    getAppJournalierSuccess(state, action) {
      state.isLoading = false;
      state.appJournalier = action.payload;
    },

    // GET RAPPORT BY AGENT
    getAgentRapportSuccess(state, action) {
      state.isLoading = false;
      state.agentRapport = action.payload;
    },

    // GET RAPPORT BY SUPERVISOR
    getSupRapportSuccess(state, action) {
      state.isLoading = false;
      state.supRapport = action.payload;
    },

    // GET RAPPORT AG + SUPERVISOR
    getASRapportSuccess(state, action) {
      state.isLoading = false;
      state.agentsupRapport = action.payload;
    },

    // GET APP LOT Gagnant
    getAppTirageLotGagnantSuccess(state, action) {
      state.isLoading = false;
      state.appTirageLotgagnant = action.payload;
    },

    // GET APP TIRAGE
    getAppTirageSuccess(state, action) {
      state.isLoading = false;
      state.appTirage = action.payload;
    },

    // GET APP FICHE
    getAppFicheSuccess(state, action) {
      state.isLoading = false;
      state.appFiche = action.payload;
    },

    // GET APP LOTTO
    getAppLottoSuccess(state, action) {
      state.isLoading = false;
      state.appLotto = action.payload;
    },

    // GET APP GAIN
    getAppGainSuccess(state, action) {
      state.isLoading = false;
      state.appGain = action.payload;
    },

    // GET APP GPC
    getAppGpcSuccess(state, action) {
      state.isLoading = false;
      state.appGpc = action.payload;
    },

    // GET TYPEGAME
    getTypeGameSuccess(state, action) {
      state.isLoading = false;
      state.error = null; // Réinitialise les erreurs

      const payload = action.payload || {};

      // Assure que nous avons toujours la bonne structure
      state.typeGame = {
        data: Array.isArray(payload.results)
          ? payload.results
          : Array.isArray(payload.data)
          ? payload.data
          : [],
        total: Number.isInteger(payload.count)
          ? payload.count
          : Number.isInteger(payload.total)
          ? payload.total
          : 0,
        next: payload.next || null,
        previous: payload.previous || payload.prev || null
      };

      // Optionnel: Log pour debug
      console.log('TypeGame chargés:', {
        count: state.typeGame.data.length,
        total: state.typeGame.total
      });
    },
    // GET TYPEGAMEAGENT
    getTypeGameAgentSuccess(state, action) {
      state.isLoading = false;
      state.error = null;

      const payload = action.payload || {};

      state.typeGameAgent = {
        data: Array.isArray(payload.results)
          ? payload.results
          : Array.isArray(payload.data)
          ? payload.data
          : [],
        total: Number.isInteger(payload.count)
          ? payload.count
          : Number.isInteger(payload.total)
          ? payload.total
          : 0,
        next: payload.next || null,
        previous: payload.previous || payload.prev || null
      };
    },

    // GET TYPEBOULE
    getTypeBouleSuccess(state, action) {
      state.isLoading = false;
      state.error = null; // Réinitialise les erreurs

      const payload = action.payload || {};

      // Assure que nous avons toujours la bonne structure
      state.typeBoule = {
        data: Array.isArray(payload.results)
          ? payload.results
          : Array.isArray(payload.data)
          ? payload.data
          : [],
        total: Number.isInteger(payload.count)
          ? payload.count
          : Number.isInteger(payload.total)
          ? payload.total
          : 0,
        next: payload.next || null,
        previous: payload.previous || payload.prev || null
      };

      // Optionnel: Log pour debug
      console.log('TypeBoules chargées:', {
        count: state.typeBoule.data.length,
        total: state.typeBoule.total
      });
    },

    // GET TYPEBOULEAGENT
    getTypeBouleAgentSuccess(state, action) {
      state.isLoading = false;
      state.error = null;

      const payload = action.payload || {};

      state.typeBouleAgent = {
        data: Array.isArray(payload.results)
          ? payload.results
          : Array.isArray(payload.data)
          ? payload.data
          : [],
        total: Number.isInteger(payload.count)
          ? payload.count
          : Number.isInteger(payload.total)
          ? payload.total
          : 0,
        next: payload.next || null,
        previous: payload.previous || payload.prev || null
      };
    },

    // GET INFOTIRAGE
    getInfoTirageSuccess(state, action) {
      state.isLoading = false;
      state.infotirages = action.payload;
    },

    getLimiteFicheSuccess(state, action) {
      state.isLoading = false;
      state.limiteFiche = action.payload;
    },
    // GET STATISTIQUES
    getStatistiqueSuccess(state, action) {
      state.isLoading = false;
      state.statistiques = action.payload;
    },

    // GET TRANSACTION
    getTransactionSuccess(state, action) {
      state.isLoading = false;
      state.transaction = action.payload;
    },

    // GET TRACABILITE AGENTS
    getTracabiliteAgentSuccess(state, action) {
      state.isLoading = false;
      state.tracabiliteAgent = action.payload.results;
      state.totalCount = action.payload.count;
      state.nextPage = action.payload.next;
      state.previousPage = action.payload.previous;
    },

    // GET TRACABILITE SUPERVISORS
    getTracabiliteSupervisorSuccess(state, action) {
      state.isLoading = false;
      state.tracabiliteSupervisor = action.payload.results;
      state.totalCount = action.payload.count;
      state.nextPage = action.payload.next;
      state.previousPage = action.payload.previous;
    },

    // GET TRACABILITE COMPANIES
    // getTracabiliteCompanySuccess(state, action) {
    //   state.isLoading = false;
    //   state.tracabiliteCompany = action.payload.results;
    //   state.totalCount = action.payload.count;
    //   state.nextPage = action.payload.next;
    //   state.previousPage = action.payload.previous;
    // },

    getTracabiliteCompanySuccess(state, action) {
      state.isLoading = false;

      // Si l'API retourne { count, next, previous, results: [...] }
      if (action.payload.results) {
        state.tracabiliteCompany = action.payload.results;
        state.totalCount = action.payload.count;
        state.nextPage = action.payload.next;
        state.previousPage = action.payload.previous;
      } else {
        // Si l'API retourne directement un tableau [...]
        state.tracabiliteCompany = action.payload;
        state.totalCount = action.payload.length;
        state.nextPage = null;
        state.previousPage = null;
      }
    },

    // GET RAPPORTS
    getRapportSuccess(state, action) {
      state.isLoading = false;
      state.rapports = action.payload;
    },

    // GET RAPPORTS
    getRapportAgentSuccess(state, action) {
      state.isLoading = false;
      state.rapportagents = action.payload;
    },

    // GET LOT GAGNANTS
    getLotGagnantSuccess(state, action) {
      state.isLoading = false;
      state.lotgagnants = action.payload;
    },

    // GET CONTROL AGENT
    getControlAgentSuccess(state, action) {
      state.isLoading = false;
      state.controlAgent = action.payload;
    },

    getDecaissementSuccess(state, action) {
      state.isLoading = false;
      state.decaissement = action.payload;
    },

    // GET LOT COMPAGNIES
    getCompagniesSuccess(state, action) {
      state.isLoading = false;
      state.compagnies = action.payload;
    },

    // GET LOT COMPANY PAYMENT
    getCompanyPaymentSuccess(state, action) {
      state.isLoading = false;
      state.companyPayment = action.payload;
    },

    // GET LOT MESSAGE
    getMessageSuccess(state, action) {
      state.isLoading = false;
      state.promote = action.payload;
    },

    // GET FACTURATION
    getFacturationSuccess(state, action) {
      state.isLoading = false;
      state.facturations = action.payload;
    },
    getURLFacturationSuccess(state, action) {
      state.isLoading = false;
      state.url = action.payload;
    },
    getmariageSurcussaleSuccess(state, action) {
      state.isLoading = false;
      state.mariageSurcussale = action.payload;
    },

    getmariageAgentSuccess(state, action) {
      state.isLoading = false;
      state.mariageAgent = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
// export const { onToggleFollow, deleteUser } = slice.actions;

export function getMariageAgent() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/companies/prime-mariage-agent');
      dispatch(slice.actions.getmariageAgentSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------
export function getMariageSurcussale() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        '/api/companies/prime-mariage-surcussale'
      );
      dispatch(slice.actions.getmariageSurcussaleSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getCountries() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/generals/countries');
      dispatch(slice.actions.getCountriesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getCity() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/generals/cities');
      dispatch(slice.actions.getCitySuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getLottos() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/list-lotto`);
      dispatch(slice.actions.getLottoSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getAgents() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/list-agent`);
      dispatch(slice.actions.getAgentsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getSupervisors() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/list-supervisor`);
      dispatch(slice.actions.getSupervisorsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getSurcussales() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/list-surcussale`);
      dispatch(slice.actions.getSurcussaleSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getTirages(value, value1) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/companies/list-tirage?start_date=${value}&end_date=${value1}`
      );
      dispatch(slice.actions.getTirageSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getFiches(value, value1, value2, value3, value4) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/companies/fiche?start_date=${value}&end_date=${value1}&tirage_id=${value2}&surcussale_id=${value3}&agent_id=${value4}`
      );
      dispatch(slice.actions.getFicheSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}
// ----------------------------------------------------------------------

export function getFicheGagnants(value, value1, value2, value3, value4) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/companies/fiche-gagnants?start_date=${value}&end_date=${value1}&tirage_id=${value2}&surcussale_id=${value3}&agent_id=${value4}`
      );
      dispatch(slice.actions.getFicheGagnantSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getFichePayants(value, value1, value2, value3, value4) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/companies/fiche-payants?start_date=${value}&end_date=${value1}&tirage_id=${value2}&surcussale_id=${value3}&agent_id=${value4}`
      );
      dispatch(slice.actions.getFichePayantSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}
// ----------------------------------------------------------------------

export function getFicheSupps(value, value1, value2, value3, value4) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/companies/fiche-supp?start_date=${value}&end_date=${value1}&tirage_id=${value2}&surcussale_id=${value3}&agent_id=${value4}`
      );
      dispatch(slice.actions.getFicheSuppSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}
// ----------------------------------------------------------------------

export function getTypeGames(page = 1, pageSize = 25, url = null) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const config = url
        ? { url }
        : {
            url: '/api/companies/type-games',
            params: {
              p: page,
              page_size: pageSize
            }
          };

      const response = await axios(config);
      const { data } = response;

      // Transformer les données selon le format reçu
      let formattedData;

      if (Array.isArray(data)) {
        // Cas 1: API renvoie un tableau direct
        formattedData = {
          results: data,
          count: data.length,
          next: null,
          previous: null
        };
      } else if (data && typeof data === 'object') {
        // Cas 2: API renvoie un objet paginé standard
        formattedData = {
          results: Array.isArray(data.results)
            ? data.results
            : Array.isArray(data.data)
            ? data.data
            : [],
          count:
            data.count ||
            data.total ||
            (Array.isArray(data.results)
              ? data.results.length
              : Array.isArray(data.data)
              ? data.data.length
              : 0),
          next: data.next || null,
          previous: data.previous || data.prev || null
        };
      } else {
        // Cas 3: Format inattendu
        formattedData = {
          results: [],
          count: 0,
          next: null,
          previous: null
        };
      }

      dispatch(slice.actions.getTypeGameSuccess(formattedData));
    } catch (error) {
      dispatch(slice.actions.hasError(error));

      // Gestion des erreurs d'authentification
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }

      // Optionnel: Log pour debug
      console.error('Erreur dans getTypeGames:', error);

      // Dispatch d'une erreur formatée pour garder la cohérence
      dispatch(
        slice.actions.getTypeGameSuccess({
          results: [],
          count: 0,
          next: null,
          previous: null
        })
      );
    }
  };
}
// ----------------------------------------------------------------------

export function getTypeGameAgents(page = 1, pageSize = 25, url = null) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const config = url
        ? { url }
        : {
            url: '/api/companies/type-games-agent',
            params: {
              p: page,
              page_size: pageSize
            }
          };

      const response = await axios(config);
      const { data } = response;

      // Formater la réponse selon le format reçu
      let formattedData;

      if (Array.isArray(data)) {
        // API renvoie un tableau direct
        formattedData = {
          results: data,
          count: data.length,
          next: null,
          previous: null
        };
      } else if (data && typeof data === 'object') {
        // API renvoie un objet paginé
        formattedData = {
          results: Array.isArray(data.results)
            ? data.results
            : Array.isArray(data.data)
            ? data.data
            : [],
          count:
            data.count ||
            data.total ||
            (Array.isArray(data.results)
              ? data.results.length
              : Array.isArray(data.data)
              ? data.data.length
              : 0),
          next: data.next || null,
          previous: data.previous || data.prev || null
        };
      } else {
        // Format inattendu
        formattedData = {
          results: [],
          count: 0,
          next: null,
          previous: null
        };
      }

      dispatch(slice.actions.getTypeGameAgentSuccess(formattedData));
    } catch (error) {
      dispatch(slice.actions.hasError(error));

      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }

      // En cas d'erreur, envoyer une structure vide pour éviter les crashs
      dispatch(
        slice.actions.getTypeGameAgentSuccess({
          results: [],
          count: 0,
          next: null,
          previous: null
        })
      );
    }
  };
}

// ----------------------------------------------------------------------

export function getTypeBoules(page = 1, pageSize = 25, url = null) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const config = url
        ? { url }
        : {
            url: '/api/companies/type-boules',
            params: {
              p: page,
              page_size: pageSize
            }
          };

      const response = await axios(config);
      const { data } = response;

      // Transformer les données selon le format reçu
      let formattedData;

      if (Array.isArray(data)) {
        // Cas 1: API renvoie un tableau direct (comme votre exemple)
        formattedData = {
          results: data,
          count: data.length,
          next: null,
          previous: null
        };
      } else if (data && typeof data === 'object') {
        // Cas 2: API renvoie un objet paginé standard
        formattedData = {
          results: Array.isArray(data.results)
            ? data.results
            : Array.isArray(data.data)
            ? data.data
            : [],
          count:
            data.count ||
            data.total ||
            (Array.isArray(data.results)
              ? data.results.length
              : Array.isArray(data.data)
              ? data.data.length
              : 0),
          next: data.next || null,
          previous: data.previous || data.prev || null
        };
      } else {
        // Cas 3: Format inattendu
        formattedData = {
          results: [],
          count: 0,
          next: null,
          previous: null
        };
      }

      dispatch(slice.actions.getTypeBouleSuccess(formattedData));
    } catch (error) {
      dispatch(slice.actions.hasError(error));

      // Gestion des erreurs d'authentification
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }

      // Optionnel: Log pour debug
      console.error('Erreur dans getTypeBoules:', error);

      // Dispatch d'une erreur formatée pour garder la cohérence
      dispatch(
        slice.actions.getTypeBouleSuccess({
          results: [],
          count: 0,
          next: null,
          previous: null
        })
      );
    }
  };
}
// ----------------------------------------------------------------------

export function getTypeBouleAgents(page = 1, pageSize = 25, url = null) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const config = url
        ? { url }
        : {
            url: '/api/companies/type-boules-agent',
            params: {
              p: page,
              page_size: pageSize
            }
          };

      const response = await axios(config);
      const { data } = response;

      // Formater la réponse selon le format reçu
      let formattedData;

      if (Array.isArray(data)) {
        // API renvoie un tableau direct (comme votre exemple)
        formattedData = {
          results: data,
          count: data.length,
          next: null,
          previous: null
        };
      } else if (data && typeof data === 'object') {
        // API renvoie un objet paginé standard
        formattedData = {
          results: Array.isArray(data.results)
            ? data.results
            : Array.isArray(data.data)
            ? data.data
            : [],
          count:
            data.count ||
            data.total ||
            (Array.isArray(data.results)
              ? data.results.length
              : Array.isArray(data.data)
              ? data.data.length
              : 0),
          next: data.next || null,
          previous: data.previous || data.prev || null
        };
      } else {
        // Format inattendu
        formattedData = {
          results: [],
          count: 0,
          next: null,
          previous: null
        };
      }

      dispatch(slice.actions.getTypeBouleAgentSuccess(formattedData));
    } catch (error) {
      dispatch(slice.actions.hasError(error));

      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }

      // En cas d'erreur, envoyer une structure vide pour éviter les crashs
      dispatch(
        slice.actions.getTypeBouleAgentSuccess({
          results: [],
          count: 0,
          next: null,
          previous: null
        })
      );
    }
  };
}
// ----------------------------------------------------------------------

export function getBoules(page = 1, pageSize = 25, url = null) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const config = url
        ? { url }
        : {
            url: '/api/companies/boules-block',
            params: {
              p: page,
              page_size: pageSize
            }
          };

      const response = await axios(config);
      const { data } = response;

      // Transformer les données selon le format reçu
      let formattedData;

      if (Array.isArray(data)) {
        // Cas 1: API renvoie un tableau direct
        formattedData = {
          results: data,
          count: data.length,
          next: null,
          previous: null
        };
      } else if (data && typeof data === 'object') {
        // Cas 2: API renvoie un objet paginé standard
        formattedData = {
          results: Array.isArray(data.results)
            ? data.results
            : Array.isArray(data.data)
            ? data.data
            : [],
          count:
            data.count ||
            data.total ||
            (Array.isArray(data.results)
              ? data.results.length
              : Array.isArray(data.data)
              ? data.data.length
              : 0),
          next: data.next || null,
          previous: data.previous || data.prev || null
        };
      } else {
        // Cas 3: Format inattendu
        formattedData = {
          results: [],
          count: 0,
          next: null,
          previous: null
        };
      }

      dispatch(slice.actions.getBouleSuccess(formattedData));
    } catch (error) {
      dispatch(slice.actions.hasError(error));

      // Gestion des erreurs d'authentification
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }

      // Optionnel: Log pour debug
      console.error('Erreur dans getBoules:', error);

      // Dispatch d'une erreur formatée pour garder la cohérence
      dispatch(
        slice.actions.getBouleSuccess({
          results: [],
          count: 0,
          next: null,
          previous: null
        })
      );
    }
  };
}

// ----------------------------------------------------------------------
export function getListIntervalma(page = 1, pageSize = 25, url = null) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      let config;

      if (url) {
        // Si une URL complète est fournie (pour next/previous)
        config = { url };
      } else {
        // Construction de l'URL avec les paramètres de pagination
        config = {
          url: '/api/companies/list-interval-ma',
          params: {
            p: page,
            page_size: pageSize
          }
        };
      }

      const response = await axios(config);
      dispatch(slice.actions.getIntervalMaSuccess(response.data));

      return response.data; // Retourner les données pour usage dans le composant si nécessaire
    } catch (error) {
      dispatch(slice.actions.hasError(error));

      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }

      throw error; // Re-throw pour que le composant puisse gérer l'erreur
    }
  };
}

// ------------------------------------------------------------------
export function getInfoTirages() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/info-tirage`);
      dispatch(slice.actions.getInfoTirageSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getLimitFiche() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/games/limite-fiche`);
      dispatch(slice.actions.getLimiteFicheSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}
// ----------------------------------------------------------------------

export function getPrimeConfs() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/prime`);
      dispatch(slice.actions.getPrimeConfSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getTirageConfs() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/prime-tirage`);
      dispatch(slice.actions.getTirageConfSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getAgentConfs() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/prime-agent`);
      dispatch(slice.actions.getAgentConfSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

//-----------------------------------------------------------------------
export function getSurcussaleConfs() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/prime-surcussale`);
      dispatch(slice.actions.getSurcussaleConfSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getApp() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/app`);
      dispatch(slice.actions.getAppSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getAppJournalier() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/app-journalier`);
      dispatch(slice.actions.getAppJournalierSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getAgentRapports() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/rapport-journalier`);
      dispatch(slice.actions.getAgentRapportSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getSupRapports() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/rapport-journalier-sup`);
      dispatch(slice.actions.getSupRapportSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getASRapports() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/companies/rapport-journalier-ag-sup`
      );
      dispatch(slice.actions.getASRapportSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getAppTirageLotgagnant() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/appTirage-lotgagnant`);
      dispatch(slice.actions.getAppTirageLotGagnantSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getAppTirage() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/appTirage`);
      dispatch(slice.actions.getAppTirageSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getAppFiche() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/appFiche`);
      dispatch(slice.actions.getAppFicheSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getAppLotto() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/appLotto`);
      dispatch(slice.actions.getAppLottoSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getAppGain() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/appGain`);
      dispatch(slice.actions.getAppGainSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getAppGpc() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/appGpc`);
      dispatch(slice.actions.getAppGpcSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getRapports(value, value1, value2, value3, value4, value5) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/companies/rapports?start_date=${value}&end_date=${value1}&tirage_id=${value2}&surcussale_id=${value3}&agent_id=${value4}&filter_choice=${value5}`
      );
      dispatch(slice.actions.getRapportSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getRapportAgents(
  value,
  value1,
  value2,
  value3,
  value4,
  value5
) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/companies/rapports-agent?start_date=${value}&end_date=${value1}&tirage_id=${value2}&surcussale_id=${value3}&agent_id=${value4}&filter_choice=${value5}`
      );
      console.log('responseee', response);
      dispatch(slice.actions.getRapportAgentSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getStatistiques(
  value,
  value1,
  value21,
  value2,
  value3,
  value4
) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/companies/statistiques?start_date=${value}&end_date=${value1}&tirage_id=${value21}&lotto_id=${value2}&surcussale_id=${value3}&agent_id=${value4}`
      );
      dispatch(slice.actions.getStatistiqueSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getTransactions(value, value1) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/companies/transactions?start_date=${value}&end_date=${value1}`
      );
      dispatch(slice.actions.getTransactionSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getTracabiliteAgents(
  startDate,
  endDate,
  page = 1,
  pageSize = 25,
  url = null
) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const endpoint =
        url ||
        `/api/companies/tracabilites-agents?start_date=${startDate}&end_date=${endDate}&p=${page}&page_size=${pageSize}`;
      const response = await axios.get(endpoint);
      dispatch(slice.actions.getTracabiliteAgentSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getTracabiliteSupervisors(
  value,
  value1,
  page = 1,
  pageSize = 25,
  url = null
) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const endpoint =
        url ||
        `/api/companies/tracabilites-supervisors?start_date=${value}&end_date=${value1}&p=${page}&page_size=${pageSize}`;
      const response = await axios.get(endpoint);
      dispatch(slice.actions.getTracabiliteSupervisorSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getTracabiliteCompanies(
  startDate,
  endDate,
  page = 1,
  pageSize = 25,
  url = null
) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const endpoint =
        url ||
        `/api/companies/tracabilites-companies?start_date=${startDate}&end_date=${endDate}&p=${page}&page_size=${pageSize}`;
      const response = await axios.get(endpoint);
      dispatch(slice.actions.getTracabiliteCompanySuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getLotGagnants() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/lotgagnant`);
      dispatch(slice.actions.getLotGagnantSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getCompagnies() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/generals/compagnies`);
      dispatch(slice.actions.getCompagniesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getSimpleCompagnies() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/generals/simple-compagnies`);
      dispatch(slice.actions.getCompagniesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getCompanyPayment() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/historics-payment`);
      dispatch(slice.actions.getCompanyPaymentSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getMessages() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/messages`);
      dispatch(slice.actions.getMessageSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getFacturations(value, value1, value2, which) {
  if (which === 'undefined') {
    which = 'superuser';
  }
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/generals/facturations?start_date=${value}&end_date=${value1}&company=${value2}&which=${which}`
      );
      dispatch(slice.actions.getFacturationSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getPaimentFacturations(
  StartDate,
  EndDate,
  CompanyID,
  which,
  total,
  NbAgent
) {
  if (which === 'undefined') {
    which = 'superuser';
  }
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/generals/pay-facturations?start_date=${StartDate}&end_date=${EndDate}&company=${CompanyID}&which=${which}&amount=${total}&nb_agent=${NbAgent}`
      );
      const { url } = response.data;
      if (url) {
        window.location.href = url; // Redirect to the URL
      } else {
        throw new Error('URL not found in response');
      }
      // dispatch(slice.actions.getURLFacturationSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getcontrolAgent(startDate, endDate, agentId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/report/controle-report-agent?start_date=${startDate}&end_date=${endDate}&agent_id=${agentId}`
      );
      dispatch(slice.actions.getControlAgentSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getDecaissement(startDate, endDate, agentId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/report/decaissement-agent?start_date=${startDate}&end_date=${endDate}&agent_id=${agentId}`
      );
      dispatch(slice.actions.getDecaissementSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getReportAgent(startDate, endDate, agentId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/report/report-agent?start_date=${startDate}&end_date=${endDate}&agent_id=${agentId}`
      );
      dispatch(slice.actions.getReportSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getReportSuperviseur(startDate, endDate, agentId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/report/report-superviseur?start_date=${startDate}&end_date=${endDate}&agent_id=${agentId}`
      );
      dispatch(slice.actions.getReportSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getcontrolSuperviseur(startDate, endDate, agentId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/report/controle-report-superviseur?start_date=${startDate}&end_date=${endDate}&agent_id=${agentId}`
      );
      dispatch(slice.actions.getReportSuperviseurSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------
export function getSuperviseur() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/list-superviseur`);
      dispatch(slice.actions.getAgentsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}
